"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateInsurerDto = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const swagger_1 = require("@nestjs/swagger");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const response_utils_1 = require("../../../../../../../libs/service-lib/src/lib/utils/response.utils");
class UpdateInsurerDto {
}
exports.UpdateInsurerDto = UpdateInsurerDto;
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Insurer Name must be a string." }),
    (0, class_validator_1.MaxLength)(200, { message: "Insurer Name must not exceed 200 characters." }),
    (0, class_transformer_1.Transform)(({ value }) => {
        value = value ? value.trim() : value;
        if (value?.length === 0) {
            throw new common_1.BadRequestException("Insurer Name should not be null or empty.");
        }
        return value;
    }),
    tslib_1.__metadata("design:type", String)
], UpdateInsurerDto.prototype, "insurerName", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Display Name must be a string." }),
    (0, class_validator_1.MaxLength)(100, { message: "Display Name must not exceed 100 characters." }),
    (0, class_transformer_1.Transform)(({ value }) => {
        value = value ? value.trim() : value;
        if (value?.length === 0) {
            throw new common_1.BadRequestException("Insurer Display Name should not be null or empty.");
        }
        return value;
    }),
    tslib_1.__metadata("design:type", String)
], UpdateInsurerDto.prototype, "displayName", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Company Type ID must be an integer." }),
    tslib_1.__metadata("design:type", Number)
], UpdateInsurerDto.prototype, "companyTypeLid", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsUrl)({}, { message: "Website must be a valid URL." }),
    (0, class_validator_1.MaxLength)(255, { message: "Website must not exceed 255 characters." }),
    (0, class_transformer_1.Transform)(({ value }) => {
        value = value ? value.trim() : value;
        return value?.length === 0 ? null : value;
    }),
    tslib_1.__metadata("design:type", String)
], UpdateInsurerDto.prototype, "website", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Business Type (Is Life ID) must be a integer" }),
    tslib_1.__metadata("design:type", Number)
], UpdateInsurerDto.prototype, "isLifeLid", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Company Tag ID must be an integer." }),
    tslib_1.__metadata("design:type", Number)
], UpdateInsurerDto.prototype, "companyTagLid", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Insure Code must be a string." }),
    (0, class_validator_1.MaxLength)(100, { message: "Insure Code must not exceed 100 characters." }),
    (0, class_transformer_1.Transform)(({ value }) => {
        value = value ? value.trim() : value;
        return value?.length === 0 ? null : value;
    }),
    tslib_1.__metadata("design:type", String)
], UpdateInsurerDto.prototype, "insureCode", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Remarks must be a string." })
    // @MaxLength(500, { message: "Remarks must not exceed 500 characters." })
    ,
    (0, class_transformer_1.Transform)(({ value }) => {
        const cleanedValue = value ? (0, response_utils_1.removeHtmlTags)(value) : value;
        if (cleanedValue && cleanedValue.length > 500) {
            throw new common_1.BadRequestException("Insurer remarks must not exceed 500 characters ");
        }
        return value?.length === 0 ? null : value;
    }),
    tslib_1.__metadata("design:type", String)
], UpdateInsurerDto.prototype, "remarks", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsInt)({ message: "Status ID must be an integer." }),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Number)
], UpdateInsurerDto.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Updated By must be an integer." }),
    tslib_1.__metadata("design:type", Number)
], UpdateInsurerDto.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], UpdateInsurerDto.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, swagger_1.ApiProperty)({
        description: "List of addresses associated with the insurer",
        type: [Object],
        required: false,
    }),
    tslib_1.__metadata("design:type", Array)
], UpdateInsurerDto.prototype, "address", void 0);
